import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { socket } from './../../socket';

import SocketListeners from '../../Components/App/SocketListeners';


import {
    Card, 
    Button,
    Icon
} from '@salesforce/design-system-react';


function Timer(props){

    const startStop = (bool) => {
        socket.emit('onResumeOrStopTimerServer', { status: bool });
    }

    const resetTimer = () => {
        socket.emit('onResetTimerServer');
        socket.emit('event', { status: true });
    }

    const setTimer15 = () => {
        socket.emit('onSetTimerServer', { time: 15 });
    }

    const setTimer60 = () => {
        socket.emit('onSetTimerServer', { time: 60 });
    }

    const setTimer360 = () => {
        socket.emit('onSetTimerServer', { time: 300 });
    }

    const convert = (seconds) => {
        if(seconds == null) {
            seconds = 0;
        }
        var minutes = 0;
        if (seconds / 60 > 0) {
            minutes = parseInt(seconds / 60, 10);
            seconds = seconds % 60;
        }
        if (minutes / 60 > 0) {
            minutes = minutes % 60;
        }
        return ('' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2);
    }
    //TODO: add start stop buttons, fix color scheme

    return (
        <Card
            heading={<span style={{ fontWeight: '500', color: '#555'}}>Timer</span>}
            className="slds-p-right_medium"
            bodyClassName="limited-card-margins"
        >           
            <div>
                {/*<SocketListeners></SocketListeners>*/}
                <div className="slds-grid slds-p-bottom_xx-small">
                    <div className="slds-size_5-of-12 slds-align_absolute-center">
                        <h1 style={{ fontSize: "2.3rem", letterSpacing: ".125em", color: '#1B96FF' }}>{convert(props.countdown)}</h1>
                    </div>
                    <div className="slds-size_6-of-12">
                        <div className="slds-grid slds-p-bottom_xx-small">
                            <Button
                                title="Start"
                                className="slds-size_1-of-3 slds-align_absolute-center"
                                variant="brand" 
                                onClick={_ => startStop(true)}
                            >Play</Button>
                            <Button 
                                className="slds-size_1-of-3 slds-align_absolute-center"
                                variant="brand" 
                                onClick={_ => startStop(false)}
                            >Pause</Button>
                            <Button 
                                className="slds-size_1-of-3 slds-align_absolute-center"
                                variant="brand" 
                                onClick={resetTimer}
                            >Reset</Button>
                        </div>
                        <div className="slds-grid">
                            <Button 
                                className="slds-size_1-of-3 slds-align_absolute-center "
                                variant="outline-brand" 
                                label="+15s"
                                onClick={setTimer15} 
                            />
                            <Button 
                                className="slds-size_1-of-3 slds-align_absolute-center "
                                variant="outline-brand" 
                                label="+1min"
                                onClick={setTimer60}
                            />
                            <Button 
                                className="slds-size_1-of-3 slds-align_absolute-center "
                                variant="outline-brand" 
                                label="+5min"
                                onClick={setTimer360}
                            />
                        </div>
                        <div className="slds-size_1-of-12" />
                    </div>
                </div>
            </div>
        </Card>

    );

}

const mapStateToProps = (state) => ({
    journeyId: state.app.journeyId,
    countdown: state.app.countdown
});


export default connect(mapStateToProps)(Timer); 